export interface Position {
  x: number;
  y: number;
}

export interface Size {
  width: number;
  height: number;
}

export interface CanvasElement {
  id: string;
  type: "text" | "image" | "shape" | "table";
  position: Position;
  size: Size;
  zIndex: number;
  rotation?: number;
  opacity?: number;
}

export interface TextElement extends CanvasElement {
  type: "text";
  content: string;
  fontSize: number;
  fontFamily: string;
  fontWeight: string;
  color: string;
  textAlign: "left" | "center" | "right";
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
}

export interface ImageElement extends CanvasElement {
  type: "image";
  url: string; // Can be either a full URL or a path (e.g., /photos/image.jpeg)
  alt?: string;
}

export interface ShapeElement extends CanvasElement {
  type: "shape";
  shapeType: ShapeType;
  fill: string;
  stroke: string;
  strokeWidth: number;
  linePoints?: {
    start: Position;
    end: Position;
  };
}

export interface TableElement extends CanvasElement {
  type: "table";
  rows: number;
  columns: number;
  cellData: string[][];
  cellStyles: TableCellStyle[][];
  headerRows?: number;
  borderColor?: string;
  cellPadding?: number;
  backgroundColor?: string;
  headerBackgroundColor?: string;
  textColor?: string;
}

export interface TableCellStyle {
  fontSize?: number;
  fontFamily?: string;
  color?: string;
  textAlign?: "left" | "center" | "right";
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
}

export interface TableCellSelection {
  elementId: string;
  row: number;
  col: number;
}

export type ShapeType =
  | "rectangle"
  | "circle"
  | "line"
  | "arrow"
  | "double-arrow"
  | "triangle"
  | "diamond"
  | "star"
  | "hexagon"
  | "ellipse";

export type AnyElement =
  | TextElement
  | ImageElement
  | ShapeElement
  | TableElement;

export interface Slide {
  id: string;
  name: string;
  elements: AnyElement[];
  background: string;
}

export interface CanvasProject {
  id: string;
  name: string;
  slides: Slide[];
  currentSlideIndex: number;
  createdAt: Date;
  updatedAt: Date;
}
